import React from "react";
import styles from "./Badge.module.css";

interface BadgeProps {
	children: React.ReactNode;
	variant?: "default" | "success" | "warning" | "error";
	color?: string;
	textColor?: string;
	icon?: React.ReactNode;
	url?: string;
}

const Badge: React.FC<BadgeProps> = ({
	children,
	variant = "default",
	color,
	textColor,
	icon,
	url
}) => {
	const style: React.CSSProperties = {};

	if (color) {
		style.backgroundColor = color;
		if (!textColor) {
			style.color = isLightColor(color) ? "#000000" : "#ffffff";
		}
	}

	if (textColor) {
		style.color = textColor;
	}

	const content = (
		<>
			{icon && <span className={styles.icon} aria-hidden="true">{icon}</span>}
			{children}
		</>
	);

	const className = `${styles.badge} ${!color ? styles[variant] : ""}`;
	const styleAttr = color ? style : undefined;
	const ariaLabel = typeof children === 'string' && children ? children : undefined;

	if (url) {
		return (
			<a
				href={url}
				className={className}
				style={styleAttr}
				aria-label={ariaLabel}
			>
				{content}
			</a>
		);
	}

	return (
		<span
			className={className}
			style={styleAttr}
			aria-label={ariaLabel}
		>
			{content}
		</span>
	);
};

function isLightColor(color: string): boolean {
	const hex = color.replace("#", "");
	const r = parseInt(hex.substr(0, 2), 16);
	const g = parseInt(hex.substr(2, 2), 16);
	const b = parseInt(hex.substr(4, 2), 16);
	const brightness = (r * 299 + g * 587 + b * 114) / 1000;
	return brightness > 155;
}

export default Badge;